// extracted by mini-css-extract-plugin
module.exports = {"version":"AboutDialog_version","contentArea":"AboutDialog_contentArea"};